export const ONBOARDING_STEPS = {
  WELCOME: 1,
  PRACTICE_MODE: 2,
  ORG_PRODA_INSTRUCTIONS: 3,
  ORG_UPLOAD_CERT: 4,
  SOLE_GOVERNANCE: 3,
  HPI_I: 5,
  IDENTITY: 6,
  COMPLETE: 7,
} as const;

export const TOTAL_STEPS = 7;

/**
 * NASH HPI-I (Healthcare Provider Identifier - Individual) format:
 * 16 digits, prefix `800361`, then 2-digit issuer ID, 4-digit registration
 * sequence, and 4-digit Luhn check.
 */
export const HPI_I_VALIDATION_PATTERN = /^800361[0-9]{2}[0-9]{4}[0-9]{4}$/;

export const PRACTICE_MODES = ['organisation', 'sole_practitioner'] as const;
export type PracticeMode = (typeof PRACTICE_MODES)[number];

export const ONBOARDING_STATUSES = ['pending', 'in_progress', 'completed', 'expired'] as const;
export type OnboardingStatus = (typeof ONBOARDING_STATUSES)[number];

export const IDENTITY_STATUSES = ['not_started', 'pending', 'submitted', 'approved', 'rejected'] as const;
export type IdentityStatus = (typeof IDENTITY_STATUSES)[number];

export const SUBSCRIPTION_PLANS = ['essential', 'professional'] as const;
export type SubscriptionPlan = (typeof SUBSCRIPTION_PLANS)[number];

export const OCCUPATIONS = [
  'Medical Doctor',
  'Specialist',
  'Anaesthetist',
  'Dentist',
  'Optometrist',
  'Veterinarian',
  'Midwife',
  'Nurse Practitioner',
  'Dermatologist',
  'Other',
] as const;

export const GOVERNANCE_AGREEMENT_VERSION = '2026.03.01';

export const PARTNER_ORGANISATION = {
  name: 'MiDispensary Bondi Junction Pty Ltd',
  shortName: 'MiDispensary Bondi Junction',
} as const;
